import { useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { proNavigator } from "single-spa/react-app/ProNavigator";

interface IArgs<T> {
    param: string;
    urlToStateAdapter?: (param: string) => T;
    stateToUrlAdapter?: (state: T) => string;
}

const defaultUrlToStateAdapter = <T,>(param: string): T => param as T;
const defaultStateToUrlAdapter = <T,>(state: T): string => state as string;
export const useStateWithDeeplink = <T>(args: IArgs<T>): [state: T, setState: (state: T) => void] => {
    const { param, urlToStateAdapter = defaultUrlToStateAdapter, stateToUrlAdapter = defaultStateToUrlAdapter } = args;
    const { params } = useCurrentStateAndParams();
    const paramValue = params[param];
    const [state, setState] = useState<T>(urlToStateAdapter(paramValue));
    const onSetState = (state: T) => {
        const params = { [param]: stateToUrlAdapter(state) };
        setState(state);
        proNavigator.applyUpdateParamsAsync(params, {
            reload: false,
        });
    };
    return [state, onSetState];
};
